import { c as _c } from "react/compiler-runtime";
import { useColorScheme, Box } from '@mui/material';
import { allExpanded, defaultStyles, darkStyles, JsonView } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
export const JsonViewer = t0 => {
  const $ = _c(4);
  const {
    data
  } = t0;
  const {
    mode
  } = useColorScheme();
  const isDarkMode = mode === "dark";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "& > div": {
        background: "transparent"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isDarkMode ? darkStyles : defaultStyles;
  let t3;
  if ($[1] !== data || $[2] !== t2) {
    t3 = <Box sx={t1}><JsonView data={data} shouldExpandNode={allExpanded} style={t2} /></Box>;
    $[1] = data;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};